export class AppAnalytics {
  custId: string;
  employeeId: string;
  childSequenceId?: string;
  transactionId: string;
  transactionType: TransactionTypes;
  metaData: MetaData[];
  videoDuration?: number;
  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

class MetaData {
  key: string;
  value: string;
}

enum TransactionTypes {
  WorkOrder = 'WO',
  ServiceAppointment = 'SA',
  ServiceQuote = 'QO',
}
